import { Control, FieldErrors } from 'react-hook-form';
import { InputField } from '@/components/common/form-fields';
import { Input } from '@/components/ui/Input';

// Only characters real addresses use, so encoded payloads like "&#106&#97...@x.com" are rejected
const EMAIL_FORMAT = /^[A-Za-z0-9._+'-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

interface CompanyInformationSectionProps {
  control: Control<any>;
  errors: FieldErrors;
  phone: string;
  setPhone: (phone: string) => void;
}

export default function CompanyInformationSection({
  control,
  errors,
  phone,
  setPhone,
}: CompanyInformationSectionProps) {
  return (
    <div className="card">
      <h2 className="text-lg font-semibold mb-6">Company Information</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Company Name */}
        <Input
          name="company_name"
          control={control}
          label="Company Name"
          required
          type="text"
          placeholder="Enter company name"
          rules={{ required: 'Company name is required' }}
        />

        {/* Contact Email */}
        <Input
          name="contact_email"
          control={control}
          label="Contact Email"
          required
          type="email"
          placeholder="contact@company.com"
          rules={{
            required: 'Contact email is required',
            validate: (value: string) => EMAIL_FORMAT.test((value || '').trim()) || 'Invalid email',
          }}
        />

        {/* Contact Phone Number */}
        <InputField
          label="Phone Number"
          fieldType="phone"
          phoneValue={phone}
          onPhoneChange={setPhone}
          phoneCountry="us"
          error={errors.contact_phone_number?.message as string}
        />
      </div>
    </div>
  );
}
